export default [
  {
    path: '/attendances',
    name: 'Attendance_List',
    component: () => import('@/views/hr/attendance.vue'),
    meta: {
      authRequired: true,
      permission: 'attendances.index'
    }
  },
]
